(() => {
  if (customElements.get('payflex-product')) return;

  const formatter = new Intl.NumberFormat('en-ZA', {
    style: 'currency',
    currency: 'ZAR'
  });

  class PayflexProduct extends HTMLElement {
    connectedCallback() {
      this.price = Number(this.dataset.price);
      this.formId = this.closest('product-rerender')?.getAttribute('observe-form');
      this.amount = this.querySelector('[data-payflex-amount]');
      this.controller = new AbortController();

      document.addEventListener('variant:change', (event) => {
        if (!this.formId || event.detail?.formId !== this.formId) return;
        this.price = event.detail?.variant?.price;
        this.updateAmount();
      }, { signal: this.controller.signal });

      this.updateAmount();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    updateAmount() {
      this.hidden = !Number.isFinite(this.price) || this.price <= 5000;
      if (!this.hidden && this.amount) {
        this.amount.textContent = formatter.format(this.price / 400);
      }
    }
  }

  customElements.define('payflex-product', PayflexProduct);
})();
